export enum DashboardRoute {
  Home = '/',
  LoginRedirect = '/login-redirect',
  Dashboard = '/dashboard',
}
